export const TOOGLE_SELECT_COUNTRY = "TOOGLE_SELECT_COUNTRY";
export const UPDATE_SENDER_DETAILS = "UPDATE_SENDER_DETAILS";
export const UPDATE_SENDER_AMOUNT = "UPDATE_SENDER_AMOUNT";
export const UPDATE_RECEIVER_DETAILS = "UPDATE_RECEIVER_DETAILS";
export const UPDATE_RECEIVER_AMOUNT = "UPDATE_RECEIVER_AMOUNT";
export const UPDATE_RATE = "UPDATE_RATE";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_USER_DATA_STATE = "SET_USER_DATA_STATE";
